import React from 'react';
import { AVAILABLE_ROLES, UserRole } from './constants';

export default function InviteTeamMemberModal({
  isOpen,
  onClose,
  inviteData,
  setInviteData,
  onSubmit,
  isLoading,
  error
}) {
  if (!isOpen) return null;

  const handleInviteInputChange = (e) => {
    const { name, value } = e.target;
    setInviteData(prev => ({
      ...prev,
      [name]: name === 'roles' ? [value] : value.trim()
    }));
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="px-6 py-4 border-b flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-900">Invite Team Member</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <form onSubmit={onSubmit} className="p-6">
          {error && (
            <div className="mb-4 p-3 text-sm bg-red-50 border-l-4 border-red-500 text-red-700 rounded flex items-start">
              <svg className="h-5 w-5 text-red-500 mr-2 flex-shrink-0 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <span>{error}</span>
            </div>
          )}
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={inviteData.email}
                onChange={handleInviteInputChange}
                required
                className={`mt-1 block w-full rounded-md ${error && error.includes('email') ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300'} p-2 shadow-sm focus:border-sky-500 focus:ring-1 focus:ring-sky-500`}
              />
              {error && error.includes('email') && (
                <p className="mt-1 text-xs text-red-600">
                  {error}
                </p>
              )}
            </div>
            <div>
              <label htmlFor="roles" className="block text-sm font-medium text-gray-700">
                Role
              </label>
              <select
                id="roles"
                name="roles"
                value={inviteData.roles[0]}
                onChange={handleInviteInputChange}
                className="mt-1 block w-full rounded-md border border-gray-300 p-2 shadow-sm focus:border-sky-500 focus:ring-sky-500"
              >
                {AVAILABLE_ROLES.map(role => (
                  <option key={role.value} value={role.value}>
                    {role.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-sm text-gray-600 border-t pt-3 mt-3">
              <p className="mb-1">
                <span className="font-semibold">Note:</span> An invitation email will be sent to this address.
              </p>
              <p>
                The user will be required to set up their password and complete their profile on first login.
              </p>
            </div>
          </div>
          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading}
            >
              {isLoading ? 'Sending...' : 'Send Invitation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 